<forge-text-field [invalid]="isInvalid" [required]="isRequired" density="small" [ngClass]="textFieldClasses"
                  [showClear]="showClearButton" (forge-text-field-clear)="clearText()">
    <input #input type="text" [name]="controlName" [formControl]="formControl" (selectionChange)="onSelectionChanged()"
           autocomplete="off">

    <label *ngIf="!hideLabel" slot="label">{{label}}</label>

    <span slot="support-text-end" *ngIf="showMaxLengthHint">{{length}}/{{maxLength}}</span>

    <span *ngIf="showSupportText" class="error" slot="support-text">
        <ng-container *ngIf="showErrorMessage('required')">
            {{label}} is required
        </ng-container>
        <ng-container *ngIf="showErrorMessage('minlength')">
            {{label}} must be at least {{minLength}} characters long
        </ng-container>
        <ng-container *ngIf="showErrorMessage('maxlength')">
            {{label}} cannot be longer than {{maxLength}} characters
        </ng-container>
        <ng-container *ngIf="hasCustomValidators">
            <ng-container *ngFor="let customError of customErrors">
                <ng-container *ngIf="showErrorMessage(customError.errorKey)">
                    {{customError.message}}
                </ng-container>
            </ng-container>
        </ng-container>
    </span>
    <forge-tooltip *ngIf="tooltip">{{tooltip}}</forge-tooltip>
</forge-text-field>